'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _MenuItems = require('./MenuItems');

var _menuItemsPropTypes = require('./menuItemsPropTypes');

var _menuItemsPropTypes2 = _interopRequireDefault(_menuItemsPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SplitButtonDropdown = function SplitButtonDropdown(props) {
    var id = props.id,
        title = props.title,
        pullRight = props.pullRight,
        bsStyle = props.bsStyle,
        bsSize = props.bsSize,
        items = props.items;


    return _react2.default.createElement(
        _reactBootstrap.SplitButton,
        { title: title, id: id, pullRight: pullRight, bsStyle: bsStyle, bsSize: bsSize },
        (0, _MenuItems.getMenuItems)(items)
    );
};

SplitButtonDropdown.defaultProps = {
    id: Math.random().toString(36).substr(2, 16),
    title: '',
    bsStyle: 'default',
    items: []
};

SplitButtonDropdown.propTypes = {
    id: _propTypes2.default.string,
    title: _propTypes2.default.node,
    pullRight: _propTypes2.default.bool,
    bsStyle: _propTypes2.default.string,
    bsSize: _propTypes2.default.string,
    items: _menuItemsPropTypes2.default
};

exports.default = SplitButtonDropdown;